var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { DialogServiceConstants } from "../../../../../constants/basics/dialog.constants";
import { LookupValueQuery, LookupValueRequest } from "../../../../../models/lookups/lookup.models";
import { LookupClientService } from "../../../../../services/lookups/lookup-client.service";
import * as Enumerable from "linq";
import { LotteryPlatformClaims } from "../../../../../constants/modules/lotteryplatform.claims";
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { BrandClientService } from "../../../../../services/modules/brand-client.service";
import { TokenClient } from "../../../../../services/authentication/token-client.service";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
var BrandBasicMeta = /** @class */ (function (_super) {
    __extends(BrandBasicMeta, _super);
    function BrandBasicMeta(notificationService, i18N, dialogClientService, userClaimsService, queriesClientService, lookupService, brandClientService, dialogClient, tokenClient) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.dialogClientService = dialogClientService;
        _this.userClaimsService = userClaimsService;
        _this.queriesClientService = queriesClientService;
        _this.lookupService = lookupService;
        _this.brandClientService = brandClientService;
        _this.dialogClient = dialogClient;
        _this.tokenClient = tokenClient;
        _this.viewBrandCredit = _this.userClaimsService.hasPermission(LotteryPlatformClaims.ViewBrandCredit);
        _this.editBrandCredit = _this.userClaimsService.hasPermission(LotteryPlatformClaims.EditBrandCredit);
        return _this;
    }
    BrandBasicMeta.prototype.topup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.brandClientService.topup(this.item.brandId, this.topUpAmount)];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.loadBrandCredit()];
                    case 2:
                        _b.sent();
                        this.topUpAmount = null;
                        this.notificationService.show("Top-up", "Top-up successful", NotificationType.Success);
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        this.notificationService.show("Top-up", "Top-up failed", NotificationType.Error);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BrandBasicMeta.prototype.loadBrandCredit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queriesClientService.getData("odata/BrandCredits?$filter=brandId eq ".concat(this.item.brandId))];
                    case 1:
                        response = _a.sent();
                        this.creditModel = response.value[0];
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(BrandBasicMeta.prototype, "isAdmin", {
        get: function () {
            return this.tokenClient.isSuperAdmin();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandBasicMeta.prototype, "isFixed", {
        get: function () {
            return !this.item.isPlatformMarginPercentage && !this.item.isPlatformMarginPercentageGross;
        },
        set: function (checked) {
            if (!checked)
                return;
            this.item.isPlatformMarginPercentage = false;
            this.item.isPlatformMarginPercentageGross = false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandBasicMeta.prototype, "isFixedOperator", {
        get: function () {
            return !this.item.isOperatorMarginPercentage && !this.item.isOperatorMarginPercentageGross && !this.item.isOperatorMarginPercentagePlatformAndInsurance;
        },
        set: function (checked) {
            if (!checked)
                return;
            this.item.isOperatorMarginPercentage = false;
            this.item.isOperatorMarginPercentageGross = false;
            this.item.isOperatorMarginPercentagePlatformAndInsurance = false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandBasicMeta.prototype, "isFixedInstantGames", {
        get: function () {
            return !this.item.isInstantGamesPlatformMarginPercentage && !this.item.isInstantGamesPlatformMarginPercentageGross;
        },
        set: function (x) {
            if (x) {
                this.item.isInstantGamesPlatformMarginPercentage = false;
                this.item.isInstantGamesPlatformMarginPercentageGross = false;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandBasicMeta.prototype, "isFixedOperatorInstantGames", {
        get: function () {
            return !this.item.isInstantGamesOperatorMarginPercentage && !this.item.isInstantGamesOperatorMarginPercentageGross;
        },
        set: function (checked) {
            if (!checked)
                return;
            this.item.isInstantGamesOperatorMarginPercentage = false;
            this.item.isInstantGamesOperatorMarginPercentageGross = false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandBasicMeta.prototype, "isFixedSweepstakes", {
        get: function () {
            return !this.item.isSweepstakesPlatformMarginPercentage && !this.item.isSweepstakesPlatformMarginPercentageGross;
        },
        set: function (checked) {
            if (!checked)
                return;
            this.item.isSweepstakesPlatformMarginPercentage = false;
            this.item.isSweepstakesPlatformMarginPercentageGross = false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandBasicMeta.prototype, "isFixedOperatorSweepstakes", {
        get: function () {
            return !this.item.isSweepstakesOperatorMarginPercentage && !this.item.isSweepstakesOperatorMarginPercentageGross;
        },
        set: function (checked) {
            if (!checked)
                return;
            this.item.isSweepstakesOperatorMarginPercentage = false;
            this.item.isSweepstakesOperatorMarginPercentageGross = false;
        },
        enumerable: false,
        configurable: true
    });
    BrandBasicMeta.prototype.getImagePath = function (templatePath) {
        if (!templatePath) {
            return '';
        }
        var storageUri = this.tokenClient.storageUri;
        if (this.tokenClient.storageUri.endsWith('/')) {
            var substringed = this.tokenClient.storageUri.substr(0, this.tokenClient.storageUri.length - 1);
            storageUri = substringed;
        }
        var url = storageUri + templatePath;
        return url;
    };
    Object.defineProperty(BrandBasicMeta.prototype, "isReadonly", {
        get: function () {
            if (this.item.isEditable)
                return !this.item.isEditable;
            else
                return !this.tokenClient.isBrandAdmin();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandBasicMeta.prototype, "isActiveReadonly", {
        get: function () {
            if (!this.item.insuranceAccountId)
                return true;
            return this.isReadonly;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandBasicMeta.prototype, "isSuperAdmin", {
        get: function () {
            return this.tokenClient.isSuperAdmin();
        },
        enumerable: false,
        configurable: true
    });
    BrandBasicMeta.prototype.showSelectTemplateDialog = function () {
        require("../dialogs/select-template-dialog");
        this.dialogClientService.show(DialogServiceConstants.URLs.SelectTemplateDialog, this);
    };
    BrandBasicMeta.prototype.onActivated = function (item) {
        var _this = this;
        this.cannotSeeCosts = !this.userClaimsService.hasPermission(LotteryPlatformClaims.BrandShowCostsOfOperatorMargins)
            && !this.userClaimsService.hasPermission(LotteryPlatformClaims.BrandShowCostsOfPlatformMargins);
        this.showPlatformMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.BrandShowCostsOfPlatformMargins);
        this.showOperatorMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.BrandShowCostsOfOperatorMargins);
        this.cannotSeeInstantGamesCosts = !this.userClaimsService.hasPermission(LotteryPlatformClaims.InstantGamesBrandShowCostsOfOperatorMargins)
            && !this.userClaimsService.hasPermission(LotteryPlatformClaims.InstantGamesBrandShowCostsOfPlatformMargins);
        this.showInstantGamesPlatformMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.InstantGamesBrandShowCostsOfPlatformMargins);
        this.showInstantGamesOperatorMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.InstantGamesBrandShowCostsOfOperatorMargins);
        this.cannotSeeBundlesCosts = !this.userClaimsService.hasPermission(LotteryPlatformClaims.BundlesBrandShowCostsOfOperatorMargins)
            && !this.userClaimsService.hasPermission(LotteryPlatformClaims.BundlesBrandShowCostsOfPlatformMargins);
        this.showBundlesPlatformMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.BundlesBrandShowCostsOfPlatformMargins);
        this.showBundlesOperatorMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.BundlesBrandShowCostsOfOperatorMargins);
        this.showBrandLevelLotteryMarginCost = this.userClaimsService.hasPermission(LotteryPlatformClaims.BrandLevelLotteryMarginCosts);
        this.cannotSeeSyndicatesCosts = !this.userClaimsService.hasPermission(LotteryPlatformClaims.SyndicatesBrandShowCostsOfOperatorMargins)
            && !this.userClaimsService.hasPermission(LotteryPlatformClaims.SyndicatesBrandShowCostsOfPlatformMargins);
        this.showSyndicatesPlatformMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.SyndicatesBrandShowCostsOfPlatformMargins);
        this.showSyndicatesOperatorMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.SyndicatesBrandShowCostsOfOperatorMargins);
        this.cannotSeeSweepstaksCosts = !this.userClaimsService.hasPermission(LotteryPlatformClaims.SweepstakesBrandShowCostsOfPlatformMargins)
            && !this.userClaimsService.hasPermission(LotteryPlatformClaims.SweepstakesBrandShowCostsOfOperatorMargins);
        this.showSweepstakesPlatformMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.SweepstakesBrandShowCostsOfPlatformMargins);
        this.showSweepstakesOperatorMargin = this.userClaimsService.hasPermission(LotteryPlatformClaims.SweepstakesBrandShowCostsOfOperatorMargins);
        // added these field in model to used validation in brand.ts
        this.item.isFixedPlatformLottery = this.checkIfLotteryIsFixedPlatformMargin();
        this.item.isFixedOperatorLottery = this.checkIfLotteryIsFixedOperatorMargin();
        this.item.isFixedPlatformBundle = this.checkIfBundleFixedPlatformMargin();
        this.item.isFixedOperatorBundle = this.checkIfBundleFixedOperatorMargin();
        this.item.isFixedPlatformSyndicate = this.checkIfSyndicateFixedPlatformMargin();
        this.item.isFixedOperatorSyndicate = this.checkIfSyndicateFixedOperatorMargin();
        this.item.isFixedPlatformInstant = this.checkIfInstantGameFixedPlatformMargin();
        this.item.isFixedOperatorInstant = this.checkIfInstantGameFixedOperatorMargin();
        this.item.isFixedPlatformSweepstake = this.checkIfSweepstakeFixedPlatformMargin();
        this.item.isFixedOperatorSweepstake = this.checkIfSweepstakeFixedOperatorMargin();
        var request = new LookupValueRequest();
        request.lookupValueQuery = LookupValueQuery.templates;
        this.lookupService.getLookup(request).then(function (x) {
            _this.templates = x;
            _this.selectedTemplate = Enumerable.from(x.values).firstOrDefault(function (x) { return x.id == item.templateId; });
        });
        this.loadStats(false);
        this.loadBrandCredit();
    };
    // checking for  lottery platform margin
    BrandBasicMeta.prototype.checkIfLotteryIsFixedPlatformMargin = function () {
        return !this.item.isPlatformMarginPercentage
            && !this.item.isPlatformMarginPercentageGross
            && !this.item.isBrandLevelLotteryMarginCost;
    };
    // checking for lottery operator margin
    BrandBasicMeta.prototype.checkIfLotteryIsFixedOperatorMargin = function () {
        return this.item.isOperatorMarginPercentage == false &&
            this.item.isOperatorMarginPercentageGross == false &&
            this.item.isOperatorMarginPercentagePlatformAndInsurance == false;
    };
    // checking for bundle platform margin
    BrandBasicMeta.prototype.checkIfBundleFixedPlatformMargin = function () {
        return this.item.isBundlesPlatformMarginPercentage == false
            && this.item.isBundlesPlatformMarginPercentageGross == false;
    };
    // checking for brand level lottery margin cost
    BrandBasicMeta.prototype.checkIfBrandLevelLotteryMarginCost = function () {
        return this.item.isPlatformMarginPercentage == false
            && this.item.isPlatformMarginPercentageGross == false
            && this.item.isBrandLevelLotteryMarginCost == false;
    };
    // cheking for bundle operator margin
    BrandBasicMeta.prototype.checkIfBundleFixedOperatorMargin = function () {
        return this.item.isBundlesOperatorMarginPercentagePlatformAndInsurance == false
            && this.item.isBundlesOperatorMarginPercentage == false
            && this.item.isBundlesOperatorMarginPercentageGross == false;
    };
    // checking for syndicates platform margin
    BrandBasicMeta.prototype.checkIfSyndicateFixedPlatformMargin = function () {
        return this.item.isSyndicatesPlatformMarginPercentage == false
            && this.item.isSyndicatesPlatformMarginPercentageGross == false;
    };
    // checking for syndicates operator margin
    BrandBasicMeta.prototype.checkIfSyndicateFixedOperatorMargin = function () {
        return this.item.isSyndicatesOperatorMarginPercentagePlatformAndInsurance == false
            && this.item.isSyndicatesOperatorMarginPercentage == false
            && this.item.isSyndicatesOperatorMarginPercentageGross == false;
    };
    // checking for instant game platform margin
    BrandBasicMeta.prototype.checkIfInstantGameFixedPlatformMargin = function () {
        return this.item.isInstantGamesPlatformMarginPercentage == false
            && this.item.isInstantGamesPlatformMarginPercentageGross == false;
    };
    // checking for instant game operator margin
    BrandBasicMeta.prototype.checkIfInstantGameFixedOperatorMargin = function () {
        return this.item.isInstantGamesOperatorMarginPercentagePlatformAndInsurance == false
            && this.item.isInstantGamesOperatorMarginPercentage == false
            && this.item.isInstantGamesOperatorMarginPercentageGross == false;
    };
    // checking for sweepstake platform margin
    BrandBasicMeta.prototype.checkIfSweepstakeFixedPlatformMargin = function () {
        return this.item.isSweepstakesPlatformMarginPercentage == false
            && this.item.isSweepstakesPlatformMarginPercentageGross == false;
    };
    // checking for sweepstake operator margin
    BrandBasicMeta.prototype.checkIfSweepstakeFixedOperatorMargin = function () {
        return this.item.isSweepstakesOperatorMarginPercentagePlatformAndInsurance == false
            && this.item.isSweepstakesOperatorMarginPercentage == false
            && this.item.isSweepstakesOperatorMarginPercentageGross == false;
    };
    BrandBasicMeta.prototype.loadStats = function (showAll) {
        var _this = this;
        this.showAll = showAll;
        this.brandClientService.getBrandOrOperatorStats(this.item.brandId, null, showAll).then(function (x) { return _this.brandStats = x; })
            .catch(function (e) { return _this.notificationService.show(_this.i18N.tr('error-text') + "!", "Error loading stats for Brand", NotificationType.Error); });
    };
    BrandBasicMeta.prototype.onTemplateSelected = function (template) {
        var _this = this;
        this.item.templateId = template.id;
        this.selectedTemplate = Enumerable.from(this.templates.values).firstOrDefault(function (x) { return x.id == _this.item.templateId; });
    };
    BrandBasicMeta.prototype.validateBrandLotteryMarginEnable = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var validationData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.brandClientService.validateBrandLotteryMarginCost(this.item.brandId)];
                    case 1:
                        validationData = _a.sent();
                        if (!validationData || !validationData.isValid) {
                            this.notificationService.show(this.i18N.tr('error-text'), this.i18N.tr('lottery-margin-cost-not-set-error-message'), NotificationType.Error);
                            require("../dialogs/brand-lottery-margin-cost-dialog");
                            this.dialogClient.show(DialogServiceConstants.URLs.BrandLotteryMarginCostDialog, validationData, true, true);
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, true];
                }
            });
        });
    };
    BrandBasicMeta = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService,
            I18N,
            DialogClientService,
            UserClaimsService,
            QueriesClientService,
            LookupClientService,
            BrandClientService,
            DialogClientService,
            TokenClient])
    ], BrandBasicMeta);
    return BrandBasicMeta;
}(ChildComponent));
export { BrandBasicMeta };
